

































import Vue, { PropType } from 'vue';
import {
  sizes,
  genDownloadImageUrl,
} from '@/modules/image';

// interface DataType {
//   imageSrc: string | nul;
//   loading: boolean;
// }

export default Vue.extend({
  name: 'GLineupItemGroupRow',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    itemNumber: {
      type: String as PropType<string>,
    },
    name: {
      type: String as PropType<string>,
    },
    imageId: {
      type: String as PropType<string>,
    },
    publishedType: {
      type: Number as PropType<number>,
      default: null,
    },
    itemOrder: {
      type: Number as PropType<number>,
    },
    onDelete: {
      type: Function as PropType<() => void>,
    },
    onUp: {
      type: Function as PropType<() => void>,
    },
    onDown: {
      type: Function as PropType<() => void>,
    },
  },
  // data(): DataType {
  //   return {
  //     imageSrc: null,
  //     loading: false,
  //   };
  // },
  asyncComputed: {
    async imageSrc(): Promise<string | null> {
      const u = await genDownloadImageUrl(
        sizes.x512,
        this.imageId,
      );
      return u;
    },
  },
  // watch: {
  //   async imageId() {
  //     await this.fetchImage();
  //   },
  // },
  // methods: {
  //   async fetchImage() {
  //     try {
  //       this.loading = true;
  //       this.imageSrc = await genDownloadImageUrl(
  //         sizes.x512,
  //         this.imageId,
  //       );
  //     } catch (error: any) {
  //       console.log(error);
  //     } finally {
  //       this.loading = false;
  //     }
  //   },
  // },
  // async mounted() {
  //   await this.fetchImage();
  // },
});
